<ion-card>
  <ion-item>
      <ion-label position="floating">Manual Ref</ion-label>
      <ion-input type='number' [(ngModel)]="serviceJob.manualRef"></ion-input>
  </ion-item>
</ion-card>